import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 37 39',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Grupo_2664"
      data-name="Grupo 2664"
      transform="translate(-430.293 -354.343)"
    >
      <g
        id="Grupo_2664-2"
        data-name="Grupo 2664"
        transform="translate(430.293 377.898)"
      >
        <path
          id="Caminho_4543"
          data-name="Caminho 4543"
          d="M450.505,371.865a2.939,2.939,0,0,1-.866-.133l-13.009-4.321a1.78,1.78,0,0,0-1.361.1l-4.149,2.027a.572.572,0,0,1-.771-.257.584.584,0,0,1,.266-.771l4.14-2.027a2.942,2.942,0,0,1,2.236-.162L450,370.637a1.558,1.558,0,0,0,.933.029l.628-.181a3.023,3.023,0,0,0,1.027-.495l13.124-9.754a1.083,1.083,0,0,0,.409-1.133l-.133-.495a.725.725,0,0,0-.714-.562.3.3,0,0,0-.181.048l-12.419,7.68a.557.557,0,0,1-.571.019l-4.482-2.464a.575.575,0,0,1,.552-1.009l4.187,2.3,12.134-7.509a1.487,1.487,0,0,1,.78-.219,1.882,1.882,0,0,1,1.828,1.437l.124.495a2.218,2.218,0,0,1-.828,2.332L453.275,370.9a4.434,4.434,0,0,1-1.409.695l-.619.171A2.848,2.848,0,0,1,450.505,371.865Z"
          transform="translate(-430.293 -356.419)"
          fill="#ff5a00"
        />
        <path
          id="Caminho_4544"
          data-name="Caminho 4544"
          d="M446.966,363.348l-3.045-.1a.573.573,0,0,1-.552-.59.55.55,0,0,1,.59-.552l3.017.1,7.442-.133a.787.787,0,0,0,.78-.723l.066-.781a.635.635,0,0,0-.562-.685l-14.351-1.818a1.927,1.927,0,0,0-.838.076l-8.346,2.845a.573.573,0,1,1-.371-1.085l8.355-2.845a3.059,3.059,0,0,1,1.342-.133l14.351,1.817a1.792,1.792,0,0,1,1.561,1.932l-.066.771a1.948,1.948,0,0,1-1.9,1.78Z"
          transform="translate(-429.353 -356.372)"
          fill="#ff5a00"
        />
        <path
          id="Caminho_4545"
          data-name="Caminho 4545"
          d="M433.414,360.281a.571.571,0,0,1-.209-1.1l5.577-2.208a1.976,1.976,0,0,1,1.323-.019,2.3,2.3,0,0,1,1.532,2.16v.181a.576.576,0,0,1-1.152,0v-.181a1.138,1.138,0,0,0-.761-1.075.88.88,0,0,0-.542,0l-5.558,2.208A.511.511,0,0,1,433.414,360.281Z"
          transform="translate(-408.587 -356.845)"
          fill="#ff5a00"
        />
      </g>
      <g
        id="Grupo_2666"
        data-name="Grupo 2666"
        transform="translate(436.19 354.343)"
      >
        <g
          id="Grupo_2665"
          data-name="Grupo 2665"
          transform="translate(0 6.103)"
        >
          <path
            id="Caminho_4546"
            data-name="Caminho 4546"
            d="M435.089,360.737a.563.563,0,0,1-.419-.18.573.573,0,0,1,.019-.809s.581-.561,1.561-1.57a2.259,2.259,0,0,0,.542-1.466,10.8,10.8,0,0,1-1.666.466,5.174,5.174,0,0,0-1.056,1.323.574.574,0,1,1-.98-.6c.4-.647,1.161-1.751,1.856-1.855a8.284,8.284,0,0,0,1.9-.619.579.579,0,0,1,1.038.228,4.144,4.144,0,0,1-.818,3.331c-1,1.018-1.589,1.589-1.589,1.589A.556.556,0,0,1,435.089,360.737Zm1.694-5.167Z"
            transform="translate(-413.066 -353.259)"
            fill="#ff5a00"
          />
          <path
            id="Caminho_4547"
            data-name="Caminho 4547"
            d="M433.489,355.371"
            transform="translate(-408.972 -351.69)"
            fill="#ff5a00"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            id="Caminho_4548"
            data-name="Caminho 4548"
            d="M438.232,363.512c-1.409,0-4.054-.086-4.616-.723-.276-.314-1.17-1.408-.971-2.189a.569.569,0,1,1,1.1.276,3.4,3.4,0,0,0,.724,1.152,17.649,17.649,0,0,0,4.587.324,12.107,12.107,0,0,0,3.207-.828,3.027,3.027,0,0,0,.143-1.2,1.214,1.214,0,0,1-.733-.267l-.228-.171a6.165,6.165,0,0,1-2.161-2.141,5.287,5.287,0,0,0-.561-1.1.555.555,0,0,1-.229-.457.573.573,0,0,1,.571-.571c.628,0,1.151,1.342,1.294,1.751.066.181.428.609,1.76,1.6l.276.209a.383.383,0,0,0,.219-.038.563.563,0,0,1,.562-.038.549.549,0,0,1,.323.447c.086.771.19,2.607-.771,3.026a13.079,13.079,0,0,1-3.645.933C438.974,363.5,438.66,363.512,438.232,363.512Zm.837-6.757h0Zm0,0Zm0,0Z"
            transform="translate(-416.399 -349.629)"
            fill="#ff5a00"
          />
          <path
            id="Caminho_4549"
            data-name="Caminho 4549"
            d="M434.118,358.132a.569.569,0,0,1-.571-.514,1.483,1.483,0,0,1,.8-1.589.574.574,0,0,1,.447,1.056c-.019.019-.133.114-.1.428a.567.567,0,0,1-.514.619Z"
            transform="translate(-408.555 -346.429)"
            fill="#ff5a00"
          />
          <path
            id="Caminho_4550"
            data-name="Caminho 4550"
            d="M433.98,360.494a.571.571,0,0,1-.343-1.028c.647-.495.8-1.77.79-2.7l-.191.057a.572.572,0,0,1-.333-1.094,2.114,2.114,0,0,0,.637-.295.563.563,0,0,1,.59-.133.57.57,0,0,1,.38.466c.048.343.4,3.407-1.18,4.616A.6.6,0,0,1,433.98,360.494Z"
            transform="translate(-409.673 -352.598)"
            fill="#ff5a00"
          />
          <path
            id="Caminho_4551"
            data-name="Caminho 4551"
            d="M447.844,371.693h-1.989a.57.57,0,0,1-.562-.466l-.523-2.77a21.288,21.288,0,0,1-7.47-.038l-.733,2.846a.569.569,0,0,1-.552.428H433.9a.57.57,0,0,1-.571-.514l-.333-3.4c-.771-.923-4.368-5.729.152-10.249,4.691-4.692,13.209-1.542,14.18-1.161,1.247.133,4.911.637,5.548,2.056a.588.588,0,0,1-.295.761.58.58,0,0,1-.762-.3c-.247-.562-2.674-1.18-4.691-1.389l-.152-.038c-.085-.028-8.689-3.455-13.019.876-4.207,4.206-.162,8.622.009,8.812a.542.542,0,0,1,.152.333l.3,3.064h1.142l.751-2.931a.575.575,0,0,1,.666-.419,19.265,19.265,0,0,0,8.08.01.553.553,0,0,1,.457.067.617.617,0,0,1,.267.381l.542,2.893H447.4l.714-2.922a.563.563,0,0,1,.695-.419.556.556,0,0,1,.419.685l-.828,3.359A.561.561,0,0,1,447.844,371.693Z"
            transform="translate(-430.913 -354.985)"
            fill="#ff5a00"
          />
        </g>
        <path
          id="Caminho_4552"
          data-name="Caminho 4552"
          d="M439.943,360.891a.424.424,0,0,1-.19-.038.564.564,0,0,1-.343-.733,3.6,3.6,0,0,0,.209-1.19,3.445,3.445,0,1,0-6.89,0,3.506,3.506,0,0,0,.047.542.578.578,0,0,1-.485.657.563.563,0,0,1-.647-.476,4.587,4.587,0,1,1,9.117-.723,4.68,4.68,0,0,1-.276,1.58A.572.572,0,0,1,439.943,360.891Z"
          transform="translate(-425.171 -354.343)"
          fill="#ff5a00"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
